/**
 * @ngdoc enum
 * @name mx.shell.ActionDeviceVisibility
 * @module mx.shell
 *
 * @description
 * Represents the list of device visibility options
 */
export enum ActionDeviceVisibility {
	/**
	 * @ngdoc property
	 * @name mx.shell.ActionDeviceVisibility#All
	 *
	 * @description
	 * Action of such type are present on any possible device
	 */
	All = 'All',

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionDeviceVisibility#MobileOnly
	 *
	 * @description
	 * The Action available only on Mobile devices
	 */
	MobileOnly = 'MobileOnly',

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionDeviceVisibility#DesktopOnly
	 *
	 * @description
	 * The Action available only on Desktop or tablet devices
	 */
	DesktopOnly = 'DesktopOnly',
}
